import axios, { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios';

/**
 * Function to handle successful responses
 */
const handleRes = (res: AxiosResponse) => res;

/**
 * Function to handle errors
 */
const handleErr = (err: AxiosError) => Promise.reject(err);

// Create Axios instance with credentials option enabled
const api = axios.create({
  withCredentials: true,
  baseURL: process.env.REACT_APP_SERVER_URL || 'http://localhost:8000',
  // Add reasonable timeout
  timeout: 15000,
  // Ensure cookies are sent with requests
  xsrfCookieName: 'fakeSO_user',
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Add a request interceptor to the Axios instance.
 */
api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // Try to add authentication from localStorage as a fallback
    try {
      const storedUser = localStorage.getItem('fakeSO_user');
      if (storedUser && !config.headers.Authorization) {
        const userData = JSON.parse(storedUser);
        if (userData && userData.username) {
          config.headers.Authorization = `Bearer ${userData.username}`;
        }
      }
    } catch (e) {
      // Silent error handling
    }
    return config;
  },
  (error: AxiosError) => handleErr(error),
);

/**
 * Add a response interceptor to the Axios instance.
 */
api.interceptors.response.use(
  (response: AxiosResponse) => handleRes(response),
  (error: AxiosError) => handleErr(error),
);

export default api;
